import styled from '@emotion/styled';
import { SIZES, colorPalettes, hexToRGBA } from '@linearb/linui-common';

export const StyledLoginLoader = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: end;
  padding-block-end: ${() => SIZES.huge};
  justify-content: center;
  background-color: ${({ theme }) =>
    hexToRGBA(colorPalettes[theme.palette.mode].background.primary, 0.7)};
  z-index: ${({ theme }) => theme.zIndex.modal};
`;
